/**
 * Inline SVG favicon — rounded coral square with cutout "P" glyph.
 * Mirrors /public/favicon.svg so it can be styled, animated, and SSR'd like Logo.
 */

interface FaviconProps {
  size?: number;
  className?: string;
}

export function Favicon({ size = 32, className }: FaviconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="favicon"
      aria-label="ProvenLeap"
      role="img"
    >
      <mask id="favicon-p-cutout">
        <rect width="32" height="32" fill="white" />
        <g transform="translate(-11.8 -9.27) scale(2.45)">
          <path
            fill="black"
            d="M7.80175 17.5V6.692H11.6107C12.5684 6.692 13.3441 6.97583 13.9377 7.5435C14.5314 8.10683 14.8282 8.89117 14.8282 9.8965C14.8282 10.9105 14.5162 11.7035 13.8922 12.2755C13.2726 12.8475 12.4752 13.1335 11.5002 13.1335H8.97175V11.398H11.2727C11.7234 11.398 12.0787 11.2723 12.3387 11.021C12.6031 10.7653 12.7352 10.41 12.7352 9.955C12.7352 9.49567 12.6009 9.13817 12.3322 8.8825C12.0679 8.62683 11.7212 8.499 11.2922 8.499H9.86875V17.5H7.80175Z"
          />
        </g>
      </mask>
      <rect width="32" height="32" rx="8" ry="8" fill="#FF6D6F" mask="url(#favicon-p-cutout)" />
    </svg>
  );
}
